import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "compact-tools"
}
const _hoisted_3 = {
  class: "px-0 mx-0",
  style: {"white-space":"nowrap"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "compact-filter-label text-caption text-medium-emphasis"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  style: {"width":"10px"}
}
const _hoisted_9 = {
  key: 0,
  class: "compact-filter-label text-caption text-medium-emphasis"
}
const _hoisted_10 = {
  key: 1,
  class: "px-0",
  style: {"vertical-align":"top","text-align":"right"}
}
const _hoisted_11 = {
  key: 0,
  class: "pr-1"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_collection_view_tabs = _resolveComponent("ontos-collection-view-tabs")!
  const _component_ontos_show_closed_toggle = _resolveComponent("ontos-show-closed-toggle")!
  const _component_ontos_check_menu = _resolveComponent("ontos-check-menu")!
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_ontos_instance_identifier = _resolveComponent("ontos-instance-identifier")!
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ontos_choice_input = _resolveComponent("ontos-choice-input")!
  const _component_ontos_person_select = _resolveComponent("ontos-person-select")!
  const _component_ontos_instance_rel_input = _resolveComponent("ontos-instance-rel-input")!
  const _component_ontos_instance_state_input = _resolveComponent("ontos-instance-state-input")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_hidden_count = _resolveComponent("ontos-hidden-count")!
  const _component_ontos_instance_list_row = _resolveComponent("ontos-instance-list-row")!
  const _component_ontos_colored_option = _resolveComponent("ontos-colored-option")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ontos_table_fit = _resolveComponent("ontos-table-fit")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ontos_view_instance_dialog = _resolveComponent("ontos-view-instance-dialog")!
  const _component_ontos_image_preview_dialog = _resolveComponent("ontos-image-preview-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, {
              title: _ctx.idea.pluralName
            }, _createSlots({
              actions: _withCtx(() => [
                (_ctx.isThereWorkflowWithClosedStates())
                  ? (_openBlock(), _createBlock(_component_ontos_show_closed_toggle, {
                      key: 0,
                      modelValue: _ctx.isShowClosedItems,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShowClosedItems) = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ontos_check_menu, {
                  icon: "mdi-format-columns",
                  label: _ctx.$tt('column-config'),
                  items: _ctx.columnMenuItems,
                  "model-value": _ctx.visibleColumns,
                  min: 1,
                  "onUpdate:modelValue": _ctx.onColumnsChange
                }, null, 8, ["label", "items", "model-value", "onUpdate:modelValue"]),
                (_ctx.canCreateIn(_ctx.idea) && _ctx.$vuetify.display.xs)
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 1,
                      icon: "mdi-plus",
                      label: _ctx.$tt('instance-create', {collection: _ctx.idea.name}),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestCreation(_ctx.idea.alias)))
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_ctx.$vuetify.display.xs)
                ? {
                    name: "tabs",
                    fn: _withCtx(() => [
                      _createVNode(_component_ontos_collection_view_tabs, {
                        idea: _ctx.idea,
                        ideas: _ctx.workspace.ideas
                      }, null, 8, ["idea", "ideas"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["title"]),
            _createVNode(_component_v_row, {
              "no-gutters": _ctx.isThereWorkflowWithClosedStates()
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ontos_table_fit, {
                      "columns-key": _ctx.visibleColumns.join(',')
                    }, {
                      default: _withCtx(({ compact }) => [
                        (compact && _ctx.idea.properties.length && _ctx.instances.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createVNode(_component_v_btn, {
                                size: "small",
                                variant: "tonal",
                                "prepend-icon": "mdi-filter",
                                color: _ctx.showFilter ? 'primary' : undefined,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$tt('filter.text')), 1)
                                ]),
                                _: 1
                              }, 8, ["color"]),
                              _createVNode(_component_v_menu, { location: "bottom start" }, {
                                activator: _withCtx(({props: menuProps}) => [
                                  _createVNode(_component_v_btn, _mergeProps(menuProps, {
                                    size: "small",
                                    variant: "tonal",
                                    "prepend-icon": "mdi-sort"
                                  }), {
                                    default: _withCtx(() => [
                                      (_ctx.currentSort)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.currentSort.title) + " ", 1),
                                            _createVNode(_component_v_icon, {
                                              end: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.currentSort.order === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$tt('sort')), 1)
                                          ], 64))
                                    ]),
                                    _: 1
                                  }, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    density: "compact",
                                    "min-width": "200"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortableHeaders, (header) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: header.key,
                                          title: header.title,
                                          active: !!_ctx.currentSort && _ctx.sortBy[0].key === header.key,
                                          onClick: ($event: any) => (_ctx.sortOn(header.key))
                                        }, _createSlots({ _: 2 }, [
                                          (_ctx.currentSort && _ctx.sortBy[0].key === header.key)
                                            ? {
                                                name: "append",
                                                fn: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { size: "small" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.currentSort.order === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                key: "0"
                                              }
                                            : undefined
                                        ]), 1032, ["title", "active", "onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.idea.properties.length)
                          ? (_openBlock(), _createBlock(_component_v_data_table, {
                              key: 1,
                              ref: "instancesTable",
                              tabindex: "-1",
                              "onClick:row": _cache[9] || (_cache[9] = (event, {item}) => _ctx.openRow(event, item)),
                              "sort-by": _ctx.sortBy,
                              "onUpdate:sortBy": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sortBy) = $event)),
                              "hide-default-header": compact,
                              headers: _ctx.headers,
                              items: _ctx.instances,
                              "items-per-page-options": _ctx.itemsPerPageOptions,
                              "items-per-page": _ctx.itemsPerPage,
                              class: "ontos-list-table",
                              "row-props": {class: 'ontos-list-row'},
                              "item-value": "_instance",
                              "mobile-breakpoint": "0",
                              hover: ""
                            }, _createSlots({
                              [`item._identifier`]: _withCtx(({ item }) => [
                                _createVNode(_component_ontos_instance_identifier, {
                                  instance: item,
                                  idea: _ctx.idea
                                }, null, 8, ["instance", "idea"])
                              ]),
                              [`item._filter`]: _withCtx(({ item }) => [
                                _createVNode(_component_ontos_color_accent, {
                                  row: "",
                                  color: _ctx.instanceColorOf(item)
                                }, null, 8, ["color"])
                              ]),
                              [`header._filter`]: _withCtx(({  }) => [
                                _createElementVNode("div", _hoisted_3, [
                                  _withDirectives(_createVNode(_component_v_btn, {
                                    variant: "plain",
                                    size: "small",
                                    icon: "",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.enableFilter(); _ctx.focusFilter(_ctx.headers[1].key)})
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createTextVNode("mdi-filter", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512), [
                                    [_vShow, !_ctx.showFilter && _ctx.instances.length > 1]
                                  ])
                                ])
                              ]),
                              [`body.prepend`]: _withCtx(({ }) => [
                                _createElementVNode("tr", {
                                  class: _normalizeClass(["elevation-5", {'compact-filter-row': compact}])
                                }, [
                                  (_ctx.showFilter && _ctx.instances.length > 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (!compact)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_4))
                                          : _createCommentVNode("", true),
                                        (_ctx.hasCompositeIdentifier(_ctx.idea) && !compact)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_5))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProperties, (property) => {
                                          return (_openBlock(), _createElementBlock("td", {
                                            key: property.alias,
                                            style: {"vertical-align":"top","max-width":"200px"},
                                            class: "pl-3 py-1"
                                          }, [
                                            (compact && _ctx.isFilterable(property))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(property.name), 1))
                                              : _createCommentVNode("", true),
                                            (_ctx.isFilterable(property))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                  (_ctx.isRangeType(property))
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        (property.type === 'date')
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(_toDisplayString(_ctx.filters.maximum[property.alias]) + " ", 1),
                                                              _createVNode(_component_v_text_field, {
                                                                class: "compact",
                                                                type: "date",
                                                                density: "compact",
                                                                variant: "outlined",
                                                                clearable: "",
                                                                "hide-details": "",
                                                                label: _ctx.$tt('filter.min'),
                                                                counter: property.length,
                                                                ref_for: true,
                                                                ref: `filter-minimum-${property.alias}`,
                                                                modelValue: _ctx.filters.minimum[property.alias],
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters.minimum[property.alias]) = $event)
                                                              }, null, 8, ["label", "counter", "modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_v_text_field, {
                                                                class: "compact mt-1",
                                                                type: "date",
                                                                density: "compact",
                                                                clearable: "",
                                                                variant: "outlined",
                                                                "hide-details": "",
                                                                label: _ctx.$tt('filter.max'),
                                                                counter: property.length,
                                                                ref_for: true,
                                                                ref: `filter-maximum-${property.alias}`,
                                                                modelValue: _ctx.filters.maximum[property.alias],
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters.maximum[property.alias]) = $event)
                                                              }, null, 8, ["label", "counter", "modelValue", "onUpdate:modelValue"])
                                                            ], 64))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createVNode(_component_v_text_field, {
                                                                class: "compact",
                                                                density: "compact",
                                                                variant: "outlined",
                                                                "hide-details": "",
                                                                label: _ctx.$tt('filter.min'),
                                                                counter: property.length,
                                                                ref_for: true,
                                                                ref: `filter-minimum-${property.alias}`,
                                                                modelValue: _ctx.filters.minimum[property.alias],
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters.minimum[property.alias]) = $event)
                                                              }, null, 8, ["label", "counter", "modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_v_text_field, {
                                                                class: "compact mt-1",
                                                                density: "compact",
                                                                variant: "outlined",
                                                                "hide-details": "",
                                                                label: _ctx.$tt('filter.max'),
                                                                counter: property.length,
                                                                ref_for: true,
                                                                ref: `filter-maximum-${property.alias}`,
                                                                modelValue: _ctx.filters.maximum[property.alias],
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters.maximum[property.alias]) = $event)
                                                              }, null, 8, ["label", "counter", "modelValue", "onUpdate:modelValue"])
                                                            ], 64))
                                                      ], 64))
                                                    : (property.type === 'choice')
                                                      ? (_openBlock(), _createBlock(_component_ontos_choice_input, {
                                                          key: 1,
                                                          class: "compact",
                                                          value: _ctx.filters.rel[property.alias],
                                                          onInput: ($event: any) => (_ctx.filters.rel[property.alias] = $event),
                                                          options: _ctx.choiceOptions(property),
                                                          label: property.name,
                                                          "hide-label": "",
                                                          outlined: "",
                                                          dense: "",
                                                          multiple: ""
                                                        }, null, 8, ["value", "onInput", "options", "label"]))
                                                      : (property.type === 'user')
                                                        ? (_openBlock(), _createBlock(_component_ontos_person_select, {
                                                            key: 2,
                                                            class: "compact",
                                                            "model-value": _ctx.filters.rel[property.alias],
                                                            "onUpdate:modelValue": ($event: any) => (_ctx.filters.rel[property.alias] = $event),
                                                            people: _ctx.workspace.people,
                                                            multiple: "",
                                                            density: "compact",
                                                            variant: "outlined",
                                                            "hide-details": ""
                                                          }, null, 8, ["model-value", "onUpdate:modelValue", "people"]))
                                                        : (property.relationship)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                              (_ctx.uniqueRelValues(property).length > 1)
                                                                ? (_openBlock(), _createBlock(_component_ontos_instance_rel_input, {
                                                                    key: 0,
                                                                    class: "compact",
                                                                    value: _ctx.filters.rel[property.alias],
                                                                    onInput: ($event: any) => (_ctx.filters.rel[property.alias] = $event),
                                                                    items: _ctx.uniqueRelValues(property),
                                                                    property: property,
                                                                    "hide-label": "",
                                                                    outlined: "",
                                                                    dense: "",
                                                                    "force-multiple": ""
                                                                  }, null, 8, ["value", "onInput", "items", "property"]))
                                                                : _createCommentVNode("", true)
                                                            ], 64))
                                                          : (_openBlock(), _createBlock(_component_v_text_field, {
                                                              key: 4,
                                                              class: "compact",
                                                              density: "compact",
                                                              variant: "outlined",
                                                              "hide-details": "",
                                                              type: property.type,
                                                              label: _ctx.$tt('filter.text'),
                                                              counter: property.length,
                                                              ref_for: true,
                                                              ref: `filter-text-${property.alias}`,
                                                              modelValue: _ctx.filters.text[property.alias],
                                                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters.text[property.alias]) = $event)
                                                            }, null, 8, ["type", "label", "counter", "modelValue", "onUpdate:modelValue"]))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128)),
                                        (_ctx.idea.workflow)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                              compact
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$tt('state')), 1))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_ontos_instance_state_input, {
                                                value: _ctx.filters.rel._state,
                                                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters.rel._state = $event)),
                                                multiple: "",
                                                workflow: _ctx.workflow,
                                                dense: "",
                                                outlined: "",
                                                "hide-label": "",
                                                class: "compact"
                                              }, null, 8, ["value", "workflow"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.showFilter && !compact)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                        _createVNode(_component_v_btn, {
                                          variant: "plain",
                                          icon: "",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showFilter = false))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                _createTextVNode("mdi-close", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              [`item._state`]: _withCtx(({ item }) => [
                                _createVNode(_component_ontos_colored_option, {
                                  option: _ctx.stateOption(item),
                                  dot: ""
                                }, null, 8, ["option"])
                              ]),
                              _: 2
                            }, [
                              _renderList(_ctx.headers.slice(0, _ctx.headers.length), (h) => {
                                return {
                                  name: h.slot,
                                  fn: _withCtx(({ column }) => [
                                    _createElementVNode("span", null, _toDisplayString(column.title), 1),
                                    (_ctx.isFiltered(column.key) && !_ctx.showFilter)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                    _ctx.showFilter = true
                  ), ["stop"])),
                                          key: `isFiltered-${h.key}`
                                        }, _toDisplayString(_ctx.$tt('filter.active')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                }
                              }),
                              _renderList(_ctx.idea.properties, (property) => {
                                return {
                                  name: `item.${property.alias}`,
                                  fn: _withCtx(({ item }) => [
                                    (_ctx.fieldVisible(item, property))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (property.relationship && !_ctx.asArray(_ctx.propValue(item, property.alias)).every(v => v._identifier))
                                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                key: property.alias,
                                                color: "teal",
                                                indeterminate: ""
                                              }))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.propertyItems(property, item), (value, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: property.alias + '.' + index
                                                }, [
                                                  (index > 0 && _ctx.needsValueSeparator(property))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " | "))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(_component_ontos_property_value, {
                                                    property: property,
                                                    value: value,
                                                    item: item,
                                                    context: {..._ctx.$route.params, instance: item._instance},
                                                    "choice-domains": _ctx.workspace.domains,
                                                    variant: "cell",
                                                    onPreview: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imagePreview = $event)),
                                                    onLink: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInstanceLink($event.event, $event.context)))
                                                  }, null, 8, ["property", "value", "item", "context", "choice-domains"])
                                                ], 64))
                                              }), 128)),
                                          (_openBlock(), _createBlock(_component_ontos_hidden_count, {
                                            key: `${property.alias}.hidden`,
                                            count: _ctx.hiddenCount(item, property)
                                          }, null, 8, ["count"])),
                                          (_ctx.cellFailures(item, property))
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: `${property.alias}.failures`,
                                                size: "x-small",
                                                color: "warning",
                                                class: "ml-1",
                                                title: _ctx.cellFailures(item, property)
                                              }, {
                                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                  _createTextVNode("mdi-alert-outline", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["title"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                }
                              }),
                              compact
                                ? {
                                    name: "item",
                                    fn: _withCtx(({ item, columns }) => [
                                      _createElementVNode("tr", {
                                        class: "compact-list-item",
                                        onClick: ($event: any) => (_ctx.openRow($event, item))
                                      }, [
                                        _createElementVNode("td", {
                                          colspan: columns.length,
                                          class: "pa-0"
                                        }, [
                                          _createVNode(_component_ontos_instance_list_row, {
                                            instance: item,
                                            idea: _ctx.idea,
                                            fields: _ctx.rowFields(item),
                                            state: _ctx.workflow ? _ctx.stateOption(item) : null,
                                            context: {..._ctx.$route.params, instance: item._instance},
                                            "choice-domains": _ctx.workspace.domains
                                          }, null, 8, ["instance", "idea", "fields", "state", "context", "choice-domains"])
                                        ], 8, _hoisted_13)
                                      ], 8, _hoisted_12)
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["sort-by", "hide-default-header", "headers", "items", "items-per-page-options", "items-per-page"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["columns-key"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["no-gutters"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.instanceOnView)
        ? (_openBlock(), _createBlock(_component_ontos_view_instance_dialog, {
            key: 1,
            context: _ctx.instanceOnView,
            preview: _ctx.previewOnView,
            workspace: _ctx.workspace,
            onChanged: _cache[11] || (_cache[11] = ($event: any) => (_ctx.load())),
            onDeleted: _cache[12] || (_cache[12] = ($event: any) => (_ctx.load())),
            onClosed: _cache[13] || (_cache[13] = ($event: any) => (_ctx.instanceOnView = null)),
            onShowMessage: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('showMessage', $event))),
            onShowErrorMessage: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
          }, null, 8, ["context", "preview", "workspace"]))
        : _createCommentVNode("", true),
      (_ctx.imagePreview)
        ? (_openBlock(), _createBlock(_component_ontos_image_preview_dialog, {
            key: 2,
            src: _ctx.imagePreview.src,
            title: _ctx.imagePreview.title,
            onClosed: _cache[16] || (_cache[16] = ($event: any) => (_ctx.imagePreview = null))
          }, null, 8, ["src", "title"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}